import { withField } from '../with-field';

import { FuelCard, FuelRadio, FuelTypography } from '@frete.com/fuel-react';
import { FC } from 'react';

import * as Styled from './styled';
import { RadioCardProps } from './types';

export const RadioCard: FC<RadioCardProps> = ({
  title,
  subtitle,
  children,
  onChange,
  onClick,
  name,
  value,
  checked,
  ...props
}) => (
  <FuelCard>
    <Styled.Content slot="content">
      <Styled.Row
        onClick={() => {
          onClick?.();
          onChange?.({ target: { value, name } });
        }}
      >
        <FuelRadio {...props} name={name} value={value} checked={checked} />
        <div>
          <FuelTypography weight="bold" size="body-md" color="neutral-strong">
            {title}
          </FuelTypography>
          <FuelTypography weight="regular" size="body-sm" color="neutral-default">
            {subtitle}
          </FuelTypography>
        </div>
      </Styled.Row>
      {children}
    </Styled.Content>
  </FuelCard>
);

export const ControlledRadioCard = withField(RadioCard);
